export const CATEGORIES_REQUEST = 'CATEGORIES_REQUEST'
export const CATEGORY_REQUEST_BY_ID = 'CATEGORY_REQUEST_BY_ID'
export const CATEGORY_GET_NEW_ID = 'CATEGORY_GET_NEW_ID'
export const CATEGORY_SAVE = 'CATEGORY_SAVE'
export const CATEGORY_UPDATE = 'CATEGORY_UPDATE'
export const CATEGORIES_REPLACE = 'CATEGORIES_REPLACE'
export const CATEGORIES_SUCCESS = 'CATEGORIES_SUCCESS'